import { FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import AppButton from "../../components/form/AppButton";
import AppTextField from "../../components/form/AppTextField";
import { AuthPageShell } from "../../components/layout";
import sessionAuthApi from "../../services/sessionAuth";
import { authEntryButtonSx } from "../login/authEntryButtonSx";

export default function ForgotPasswordUI() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      const r = await sessionAuthApi.forgotPassword(email.trim());
      setMessage(r.message);
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <AuthPageShell
      title="Forgot password"
      footer={<Link to="/login">Back to login</Link>}
    >
      <Box component="form" onSubmit={onSubmit}>
        <Stack spacing={2}>
          {message && <Alert severity="success">{message}</Alert>}
          {error && <Alert severity="error">{error}</Alert>}
          <AppTextField
            label="Email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <AppButton type="submit" fullWidth variant="contained" sx={{ mt: 1.5, ...authEntryButtonSx }}>
            Send reset link
          </AppButton>
        </Stack>
      </Box>
    </AuthPageShell>
  );
}
